/**
 * Auto-generated icon registry
 * This file is generated by vite-plugins/navigation-icons.js
 * DO NOT EDIT MANUALLY - changes will be overwritten
 */

import { Component } from 'vue';

// Import all icons used in navigation
import IconBiWindowStack from '~icons/bi/window-stack';
import IconBiShieldLock from '~icons/bi/shield-lock';

// Icon registry mapping backend icon strings to components
const iconRegistry: Record<string, Component> = {
  'bi:window-stack': IconBiWindowStack,
  'bi:shield-lock': IconBiShieldLock,
};

export function useIcon(iconString: string | undefined): Component | null {
  if (!iconString) return null;

  const icon = iconRegistry[iconString];

  if (!icon) {
    console.warn(`Icon not found in registry: ${iconString}`);
    return null;
  }

  return icon;
}
